var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view",class:[_vm.mapId]},[(_vm.selectedMap.src)?_c('div',{staticClass:"map"},[_c('router-view',{key:_vm.mapId})],1):_c('ImageLoader',{attrs:{"map":_vm.selectedMap}}),_c('WhHomeButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }